import { render, staticRenderFns } from "./ActionSwitch.vue?vue&type=template&id=513cd286&"
import script from "./ActionSwitch.vue?vue&type=script&lang=js&"
export * from "./ActionSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports